import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import SEO from "components/seo";
import ReactMarkdown from "react-markdown";

const PromotionDetail = ({ promotion, langData, homeUrl, promotionUrl }) => {
  
  const RewardContent = styled.div`
    padding-top: 0px;
    padding: 50px 20px 70px 20px;
  `;
  const Promo = styled.div`
    padding-top: 0px;
    padding: 40px 20px;
    @media (max-width: 520px) {
      .promotion__content {
        max-width: 100%;
        padding: 40px 5px;
        font-style: 13px;
      }
    }
  `;
  const PromotionContent = styled.div`
    max-width: 100%;
    padding: 40px 0;
    p {
      font-size: 14px;
    }

    @media (max-width: 520px) {
      max-width: 100%;
      padding: 20px 0;
    }
  `;
  const PromoContainer = styled.div`
    width: 100%;
  `;

  const PromoDetailContainer = styled.div`
    width: 100%;
    max-width: 996px;
    margin: 0 auto;
  `;

  return (
    <>
      <SEO
        title={promotion?.promotionDetailName}
        description={promotion?.promotionDetailName}></SEO>
      <div className="page-promotion">
        <div className="container">
          <div className="mainbarpromo">
            <PromoDetailContainer>
              <Promo>
                <div className="crumb">
                  <div className="container">
                    <Link to={homeUrl}>{langData.crumb_home}</Link>
                    <Link to={promotionUrl}>{langData.crumb_promotion}</Link>
                    <Link>{promotion?.promotionDetailName}</Link>
                  </div>
                </div>

                <h1 className="promo__title">
                  {promotion?.promotionDetailName}
                </h1>

                <div className="promo__banner">
                  <img src={promotion?.promotionImage} />
                </div>

                <h1 className="promo__title--mobile tablet--only">
                  <br></br>
                  {promotion?.promotionDetailName}
                </h1>

                <PromotionContent>
                  <ReactMarkdown children={promotion?.promotionDetailContent} />
                </PromotionContent>
              </Promo>
            </PromoDetailContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromotionDetail;
